$(function () {
  $('[data-list-option]').on('change', function () {
    var query = '';
    $('[data-list-option]').each(function (index, item) {
      var value = $(item).val();
      if (value) {
        if (query) {
          query += '&';
        }
        query += $(item).attr('data-key') + '=' + value;
      }
    });

    window.location.href =
      window.location.pathname + (query ? '?' + query : '');
  });
});
